export default __webpack_public_path__ + "9dce5d80a50094ad51b2a037d00e9f21.png";